<template>
  <v-dialog 
  width="100%"
 transition="dialog-bottom-transition"
  v-model="show">
    <v-toolbar dark class="edit-item-header">
        <v-tabs style="margin-bottom:20px;">
          <v-tab
            key="driver_details"
              @click="ViewDriverDetails()"
            >
              Driver Details
            </v-tab>
            <v-tab
              v-if="driver !== undefined && driver.id !== undefined"
              key="driver_trucks"
              @click="ViewDriverTrucks()"
            >
              Assigned Trucks
            </v-tab>
            <v-tab
              v-if="driver !== undefined && driver.id !== undefined"
              key="driver_waybills"
              @click="ViewDriverWaybills()"
            >
              Trip History
            </v-tab>
              <v-tab
                v-if="driver !== undefined && driver.id !== undefined"
                key="driver_stops"
                @click="ViewDriverStops()"
              >
                Station Stops
              </v-tab>
            </v-tabs>
            <v-spacer></v-spacer>

            <!-- <v-btn icon dark textx @click="save">
              <v-icon color="primary">{{ "mdi-content-save-outline" }}</v-icon>
            </v-btn> -->

            <v-btn icon dark @click="show = false">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
            
        </v-toolbar>
        <v-card>
          <!-- <edit-item-fields v-if="view === 1"
              :entityName="entity_name" 
              :entity_fields="headers"
              :localizable_fields="localizable_fields"
              :driver="driver"
            @closeClicked="show = false;"
            fullscreen="true"
        >
        </edit-item-fields> -->


        <drive-details-tab 
              v-if="view === 1"
              :entityName="entity_name" 
              :entity_fields="headers"
              :localizable_fields="localizable_fields"
              :driver="driver"
              @closeClicked="show = false;"
              fullscreen="true">
            </drive-details-tab>

        <truck-assignments
        
          :key="truckAssignments" 
         v-if="view === 2 && driver !== undefined && driver.id !== undefined"
          :driver_id="driver.id"
          v-model="driver"
        >
        </truck-assignments>

        <waybill-tracking 
        
          :key="waybillTracking" 
        v-if="view === 3 && driver !== undefined && driver.id !== undefined"
          :driver_id="driver.id"
          :truck_id="0"
          v-model="driver"
        >
        </waybill-tracking>

        <driver-stops v-if="view === 4 && driver !== undefined && driver.id !== undefined"
          :driver_id="driver.id"
          :driver="driver"
          v-model="driver"
          :key="driverStop" 
        >
        </driver-stops>
    </v-card>
  </v-dialog>
</template>
<script>
import EditItemFields from '../common/EditItemFields'
import DriveDetailsTab from '../driver/DriveDetailsTab.vue'
import WaybillTracking from '../waybill/WaybillTracking'
import TruckAssignments from './TruckAssigments'
import DriverStops from './DriverStops'
export default {
    components:{EditItemFields,WaybillTracking,TruckAssignments,DriverStops,DriveDetailsTab},
    props:['headers','entity_name','title','driver','localizable_fields','isShown'],
    methods:{
        ViewDriverDetails(){
            this.view = 1
        },
        ViewDriverTrucks(){
            this.view = 2
        },
        ViewDriverWaybills(){
            this.view = 3
        },
        ViewDriverStops(){
          this.view = 4
        }
    },
    data(){
      this.driverStop+=1;
      this.waybillTracking+=1;
      this.truckAssignments+=1;
        return {
            view:1,
        }
    },
    created(){
        this.entity_name = 'driver'
    },  
    computed: {
        show: {
            get() {
                return this.isShown
            },
            set(value) {
                this.$emit('changed', value)
            }
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
}
</script>